import * as React from "react";
const SvgDocumentPdfFill = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M15 17a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1H5V3a1 1 0 0 1 1-1h9a1 1 0 0 1 .707.293l5 5A1 1 0 0 1 21 8v13a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1.006L5.023 17zM3 12h11v3H3z", clipRule: "evenodd" }));
export default SvgDocumentPdfFill;
